import React from "react";
import styles from "./DeviceStaticsChart.less";
import APILXD from "../../../http/APILXD";
import {Select, Input, DatePicker, message, Button, Modal, InputNumber} from "antd";
import HttpTool from "../../../tool/HttpTool";
import dayjs from 'dayjs'
import DeviceCountry from "./component/DeviceCountry.tsx";
import SpaceMsgChart from "./component/SpaceMsgChart.tsx";
import IPMsgChart from "./component/IPMsgChart.tsx";
import PhoneMsgChart from "./component/PhoneMsgChart.tsx";
import DeviceUnit from "./component/DeviceUnit.tsx";
import DeviceBusinessList from "./DeviceBusinessList";

export default class DeviceBusinessStatics extends React.Component {
  constructor(props) {
    super(props);

    this.defaultCompanyId = "jsbzy";

    this.state = {
      allCompany: [],
      companyId: this.defaultCompanyId
    }
  }

  componentDidMount() {
    HttpTool.post(APILXD.getAllSpaces, (code,msg,json)=>{
      this.setState({allCompany: json});
    },(code,msg)=>{
        message.error(msg)
    },{})
  }

  render(){
    let {companyId, allCompany} = this.state;

    return <div className={styles.mainPage}>
      <div className={styles.header}>
        <div>
          统计公司维度：<Select
          value={companyId}
          onChange={(v) => {this.setState({companyId: v})}}
          options={allCompany?.map((obj)=>{
            return {
              label: obj.name,
              value: obj._id
            }
          })}
        />
        </div>
      </div>
      <div
        style={{flex: 1, position: "relative"}}
      >
        <DeviceBusinessStaticsInner
          key={companyId}
          companyId={companyId}
          {...this.props}
        />
      </div>
    </div>
  }
}

class DeviceBusinessStaticsInner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allSpace: [],
      allCountry: [],
      spaceIds: [],  //空间
      countryId: null,  // 地区
      types: [],    //机型
      statusArr: [],  //状态
      ipStatus: null,  //ip
      phoneStatus: null,  //手机
      lasttime: [dayjs().subtract(30, 'days'), dayjs()],
      tableKey: 0,  //控制表格更新
      searchParams: {
        companyId: this.props.companyId,
        startOnLineTime: dayjs().subtract(30, 'days').valueOf(),
        endOnLineTime: dayjs().valueOf()
      },
    }
  }

  componentDidMount() {
    this.refetchData()

    this.getArea()
    this.getAllSpace()
  }

  refetchData() {
    let {spaceIds, statusArr, lasttime, countryId, types, ipStatus, phoneStatus} = this.state;

    let searchParams = {
      companyId: this.props.companyId,
      countryId: countryId,
      spaceIds: spaceIds?.length?spaceIds:null,
      status: statusArr?.length?statusArr:null,
      type: types?.length?types:null,
      ipBinding: ipStatus,
      mobileType: phoneStatus,
    }

    if(lasttime?.length){
      searchParams.startOnLineTime = lasttime[0].valueOf()
      searchParams.endOnLineTime = lasttime[1].valueOf()
    }

    console.log("searchParams", searchParams)

    this.setState({
      tableKey: this.state.tableKey + 1,
      searchParams: searchParams,
    })
  }

  getArea(){
    HttpTool.post(APILXD.getAllCountryList, (code, msg, json) => {
      this.setState({
        allCountry: json
      })
    }, (code, msg) => {
      message.error(msg);
    }, {})
  }

  getAllSpace() {
    HttpTool.post(APILXD.businessGetSpaceList, (code, msg, json) => {
      this.setState({
        allSpace: json
      })
    }, (code, msg) => {
      message.error(msg);
    }, {
      companyId: this.props.companyId
    })
  }


  render() {
    let {
      allSpace,
      allCountry,
      spaceIds,
      statusArr,
      lasttime,
      countryId,
      types,
      ipStatus,
      phoneStatus,
      searchParams,
      tableKey
    } = this.state;
    return <div className={styles.mainPage}>
      <div className={styles.header}>
        <div className={styles.flexLine}>
          <div className={styles.flexItem}>地区：
            <Select
              allowClear={true}
              placeholder={"选择地区过滤"}
              style={{minWidth: "200px"}}
              value={countryId}
              onChange={(value) => {
                this.setState({
                  countryId: value
                })
              }}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                allCountry?.map((item) => {
                  return <Select.Option
                    key={item._id}
                    value={item._id}
                  >
                    {item.name}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className={styles.flexItem}>业务空间：
            <Select
              allowClear={true}
              mode="multiple"
              maxTagCount={3}
              placeholder={"选择业务空间过滤"}
              style={{minWidth: "200px"}}
              value={spaceIds}
              onChange={(value) => {
                this.setState({
                  spaceIds: value
                })
              }}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {
                allSpace?.map((item) => {
                  return <Select.Option
                    key={item._id}
                    value={item._id}
                  >
                    {item.name}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className={styles.flexItem}>机型：
            <Select
              allowClear={true}
              mode="multiple"
              maxTagCount={3}
              placeholder={"选择机型过滤"}
              style={{minWidth: "200px"}}
              value={types}
              onChange={(value) => {
                this.setState({
                  types: value
                })
              }}
              options={[
                {
                  label: '手机',
                  value: 2,
                },
                {
                  label: 'PC',
                  value: 3,
                },
                {
                  label: '服务器',
                  value: 4,
                },
              ]}
              showSearch={false}
            />
          </div>
          <div className={styles.flexItem}>IP：
            <Select
              allowClear={true}
              placeholder={"选择IP状态过滤"}
              style={{minWidth: "200px"}}
              value={ipStatus}
              onChange={(value) => {
                this.setState({
                  ipStatus: value
                })
              }}
              options={[
                {
                  label: '无IP',
                  value: false,
                },
                {
                  label: '有IP',
                  value: true,
                },
              ]}
            />
          </div>
          <div className={styles.flexItem}>手机号：
            <Select
              allowClear={true}
              placeholder={"选择手机号状态过滤"}
              style={{minWidth: "200px"}}
              value={phoneStatus}
              onChange={(value) => {
                this.setState({
                  phoneStatus: value
                })
              }}
              options={[
                {
                  label: '无手机号',
                  value: 'noSim',
                },
                {
                  label: 'SIM',
                  value: 'sim',
                },
                {
                  label: 'ESIM',
                  value: 'eSim',
                },
              ]}
            />
          </div>
          <div className={styles.flexItem}>工作状态：
            <Select
              allowClear={true}
              placeholder={"选择状态过滤"}
              style={{width: "200px"}}
              mode={"multiple"}
              value={statusArr}
              onChange={(value) => {
                this.setState({
                  statusArr: value
                })
              }}
            >
              <Select.Option value={1}>离线</Select.Option>
              <Select.Option value={2}>空闲</Select.Option>
              <Select.Option value={3}>忙碌</Select.Option>
            </Select>
          </div>

          <div className={styles.flexItem}>上线时间：
            <DatePicker.RangePicker
              value={lasttime}
              showToday={false}
              format={"YYYY-MM-DD"}
              disabledDate={((currentDate) => {
                return (currentDate && currentDate.valueOf() >= (Date.now())) || (currentDate && currentDate.valueOf() <= (Date.now() - 86400000 * 180))
              })}
              onChange={(date, dateString) => {
                this.setState({
                  lasttime: date
                })
              }}
            />
          </div>
          <Button
            type={"primary"}
            onClick={()=>{
              this.refetchData()
            }}
          >开始过滤</Button>
          <Button
            type={"primary"}
            ghost={true}
            onClick={()=>{
              this.areaSel && this.areaSel.changeValue('country', null)

              this.setState({
                spaceIds: [],  //空间
                countryId: null,  // 地区
                types: [],    //机型
                statusArr: [],  //状态
                ipStatus: null,  //ip
                phoneStatus: null,  //手机
                lasttime: [dayjs().subtract(30, 'days'), dayjs()], //最后上线时间
              },()=>{
                this.refetchData()
              })
            }}
          >重置筛选</Button>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.chartGroupBox}>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div
              className={styles.chartBodyBoxS}
            >
              <SpaceMsgChart
                pageParams={searchParams}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 2}}
          >
            <div
              className={styles.chartBodyBoxS}
            >
              <DeviceUnit
                pageParams={searchParams}
              />
            </div>
          </div>
        </div>
        <div className={styles.chartGroupBox}>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div
              className={styles.chartBodyBoxS}
            >
              <DeviceCountry
                pageParams={searchParams}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div
              className={styles.chartBodyBoxS}
            >
              <IPMsgChart
                pageParams={searchParams}
              />
            </div>
          </div>
          <div className={styles.chartOuterBox}
               style={{flex: 1}}
          >
            <div
              className={styles.chartBodyBoxS}
            >
              <PhoneMsgChart
                pageParams={searchParams}
              />
            </div>
          </div>
        </div>
        <div
          className={styles.chartGroupBox}
        >
          <div
            style={{width: "100%"}}
          >
            <DeviceBusinessList
              key={tableKey}
              pageParams={searchParams}
              {...this.props}
            />
          </div>
        </div>
      </div>
    </div>
  }
}